Config.$inject = ['$stateProvider'];

function Config($stateProvider) {
    $stateProvider
        .state('planner.schedule', {
            url: '',
            template: '<schedule data="vm.shifts" date="vm.date" holidays="vm.holidays"></schedule>'
        })
        .state('planner.daily', {
            template: '<dailyview data="vm.shifts" holidays="vm.holidays"></dailyview>',
            params: {
                date: null
            }
        })
        .state('planner.driver', {
            template: '<driverview driver="vm.driver" shifts="vm.driversShifts" holidays="vm.holidays"></driverview>'
        });
}

export default Config;



// WEBPACK FOOTER //
// ./src/js/components/planner/routes.js